import { useMemo } from 'react';
import type { DealTemplate } from '@makemydeal/dr-dash-types';
import { hasTemplateChanged } from '../sections/utils';
import type { UseTemplateFormState } from './useTemplateForm';

export type UseTemplateValidationReturn = {
    isSubmitDisabled: boolean;
    isUpdateDisabled: boolean;

    validateTemplateName: (name: string) => boolean;
    validateTemplateDescription: (description: string) => boolean;
    hasFormChanged: (templateToUpdate?: DealTemplate) => boolean;
};

export const useTemplateValidation = (
    formState: UseTemplateFormState,
    templateToUpdate?: DealTemplate
): UseTemplateValidationReturn => {
    const { templateName, templateDescription, templateNameConflictError, inventoryTypes, years, makes, models, trims } = formState;

    const validateTemplateName = (name: string): boolean => {
        return name.trim().length > 0;
    };

    const validateTemplateDescription = (description: string): boolean => {
        return description.length <= 500;
    };

    const hasFormChanged = (template?: DealTemplate): boolean => {
        if (!template) return false;

        return hasTemplateChanged(
            {
                templateName,
                templateDescription,
                inventoryTypes,
                years,
                makes,
                models,
                trims
            },
            template
        );
    };

    const isSubmitDisabled = useMemo(() => {
        return (
            !validateTemplateName(templateName) ||
            !validateTemplateDescription(templateDescription) ||
            Boolean(templateNameConflictError)
        );
    }, [templateName, templateDescription, templateNameConflictError]);

    const isUpdateDisabled = isSubmitDisabled || !hasFormChanged(templateToUpdate);

    return {
        isSubmitDisabled,
        isUpdateDisabled,
        validateTemplateName,
        validateTemplateDescription,
        hasFormChanged
    };
};
